import { clientGet } from 'data/clients/axios-api.client';
import { SubscriptionsResponseModel } from 'data/entities/subscriptions.entity';

interface ISubscriptionsDatasource {
    getSubscriptions(): Promise<SubscriptionsResponseModel | null>;
}
class SubscriptionsDatasource implements ISubscriptionsDatasource {
    public async getSubscriptions(): Promise<SubscriptionsResponseModel | null> {
        const url = `${process.env.REACT_APP_API_URL}/platform/subscriptions`;
        const result = await clientGet<SubscriptionsResponseModel>(url);
        return result.data;
    }
}
export const subscriptionsDatasource: ISubscriptionsDatasource = new SubscriptionsDatasource();
